// The words a family sees for a child's status in a year.
const PARENT_STUDENT_STATUS: Record<string, string> = {
  PENDING_FAMILY_CONFIRMATION: 'No answer yet',
  PENDING_ADMISSIONS_REVIEW: 'Waiting for approval',
  WAITLISTED: 'Waitlisted',
  ACCEPTED_PENDING_DEPOSIT: 'Coming',
  ENROLLED: 'Enrolled',
  WITHDRAWN: 'Withdrawn',
  DENIED: 'Declined by the school',
  NOT_RETURNING: 'Not coming',
};

export function parentStudentStatus(state: string): string {
  return PARENT_STUDENT_STATUS[state] ?? 'Ask the school office';
}

// All eight statuses, in the order the office's status menu lists them.
export const STUDENT_STATUSES: string[] = Object.keys(PARENT_STUDENT_STATUS);
